<!--
// app/pages/stores.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";

const { $defineI18nRoute, $t } = useNuxtApp();

definePageMeta({
  middleware: ["not-found-queens"],
  layout: "menu-free",
});

$defineI18nRoute({
  localeRoutes: {
    en: "/stores",
    es: "/tiendas",
    de: "/shops",
    fr: "/boutiques",
    it: "/negozios",
    pt: "/lojas",
    ar: "/stores",
  },
});

const bgStoreEs = "https://cms-es.kingsleague.pro/zdr854ew1p5/store/bg-store-es.jpg";
const bgStoreAm = "https://cms-es.kingsleague.pro/zdr854ew1p5/store/bg-store-am.jpg";
const logoEsFull = "/img/league-logos/spain-logo-full.svg";
const logoAmFull = "/img/league-logos/americas-logo-full.svg";

// const tiraMinibalon = "/img/store/tira_minibalon.png";
// const showTiraMinibalon = false;

const tiraBlackWeeks = "/img/store/band-black-weeks.png";
const showTiraBlackWeeks = false;
</script>

<template>
  <section
    class="grid grid-cols-1 md:grid-cols-2 md:aspect-video max-w-2xl md:max-w-[1440px] w-full gap-4 px-4"
  >
    <div :style="`background-image: url('${bgStoreEs}')`" class="banner-container relative overflow-hidden">
      <!--      <div v-if="showTiraMinibalon" class="absolute top-[55%] -left-[5%] w-[110%]">-->
      <!--        <img :src="tiraMinibalon" alt="Mini balón sólo hoy gratis" />-->
      <!--      </div>-->
      <div v-if="showTiraBlackWeeks" class="absolute -bottom-7 md:bottom-0 left-0">
        <img :src="tiraBlackWeeks" alt="Black Weeks 50%" />
      </div>

      <div class="max-h-[23%] flex flex-col justify-start items-center gap-3 md:gap-6">
        <img
          :src="logoEsFull"
          alt="España Kings League InfoJobs"
          class="w-auto max-h-[80px] bigsm:max-h-[140px] lg:max-h-[180px]"
        />
        <a href="https://store.kingsleague.pro" target="_self" class="button-store">{{
          $t("landing.stores.spainStore.button")
        }}</a>
      </div>
    </div>
    <div :style="`background-image: url('${bgStoreAm}')`" class="banner-container">
      <div class="max-h-[23%] flex flex-col justify-start items-center gap-3 md:gap-6">
        <img
          :src="logoAmFull"
          alt="Américas Kings League Santander"
          class="w-auto max-h-[80px] bigsm:max-h-[140px] lg:max-h-[180px]"
        />
        <a href="https://storeamericas.kingsleague.pro" target="_self" class="button-store">{{
          $t("landing.stores.americasStore.button")
        }}</a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.banner-container {
  @apply bg-cover aspect-square md:aspect-auto bg-no-repeat md:bg-center min-h-full w-full p-5 md:p-9;
  background-position: top 20% center;
}

.button-store {
  @apply bg-primary rounded-lg lg:min-w-[280px] sm:max-w-[200px] md:max-w-[280px] font-[Termina] uppercase font-bold text-black text-sm md:text-lg xl:text-2xl text-center px-5 py-1.5;
  filter: drop-shadow(4px 4px 4px black);
}
</style>
